import {
    Divider,
    Grid,
    IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import { useState } from "react";

import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import { Add, CreateOutlined } from "@mui/icons-material";

const VendorResponseSubMenuNew = ({
    selectedButtonName,
    setSelectedButtonName,
    handlecallProcess,
    selectedQuoteDetails
  
}) => {

    const [selectedButton, setSelectedButton] = useState(null);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedButtonName(buttonName);

        handlecallProcess(buttonName);
    };

    const getColor = (btn) =>
        selectedButton === btn ? "yellow" : "#009688";

     

    return (
        <Grid container alignItems="center" padding={0}>

            

          

            {/* Clear */}
            <Grid item>
                <Tooltip title="Create Vendor Quotation Comparison">
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <IconButton disabled={selectedQuoteDetails.status==='in_comparison'} onClick={() => handleButtonClick("CreateQuoteComparison")}>
                            <Add style={{ fontSize: 20, color: getColor("CreateQuoteComparison") }} />
                            <Typography variant="h6" sx={{ ml: 1 }}>
                                Create Quote Comparison
                            </Typography>
                        </IconButton>
                    </div>
                </Tooltip>
            </Grid>

             <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

        </Grid>
    );
};

export default VendorResponseSubMenuNew;
